import { useState, useRef } from 'react';

import path_buy from '@/assets/text/buy_2.png';
import path_donate from '@/assets/text/donate_2.png';
import path_end_turn from '@/assets/text/end_turn.png';
import path_pay_here from '@/assets/text/pay_here.png';
import path_steal from '@/assets/text/steal_2.png';
import path_store from '@/assets/text/store.png';
import { getCardMetadata } from '@/util/card';
import { logg } from '@/util/logg';

export function useViewState() {
	const [camState, setCamState] = useState('player');

	const [showTicker, setShowTicker] = useState(true);

	const [minimize, setMinimize] = useState(false);

	const [playerMatPath, setPlayerMatPath] = useState(
		'/assets/mats/yellow.png'
	);

	const [isDebug, setIsDebug] = useState(false);

	const [tickerTimeoutSeconds, setTickerTimeoutSeconds] = useState(3);

	const [currentTickerIndex, setCurrentTickerIndex] = useState(0);
	const [tickerActual, setTickerActual] = useState([]);

	const [currentTickerTimer, setCurrentTickerTimer] = useState(-1);

	const [paymentMode, setPaymentMode] = useState(false);

	const [buyButtonTexturePath, setBuyButtonTexturePath] = useState(path_buy);
	const [donateButtonTexturePath, setDonateButtonTexturePath] =
		useState(path_donate);
	const [stealButtonTexturePath, setStealButtonTexturePath] =
		useState(path_steal);
	const [storeButtonTexturePath, setStoreButtonTexturePath] =
		useState(path_store);

	const [endTurnButtonTexturePath, setEndTurnButtonTexturePath] =
		useState(path_end_turn);

	const [payHereSignTexturePath, setPayHereSignTexturePath] =
		useState(path_pay_here);

	const [showPlayermatModal, setShowPlayermatModal] = useState(false);
	const [showRulesmatModal, setShowRulesmatModal] = useState(false);

	const [showAdminStateModal, setShowAdminStateModal] = useState(false);

	const [showHandModal, setShowHandModal] = useState(false);
	const [showDiscardCardFromHandModal, setShowDiscardCardFromHandModal] =
		useState(false);
	const [showPaymentModal, setShowPaymentModal] = useState(false);
	const [showActionModal, setShowActionModal] = useState(false);
	const [showSettingsModal, setShowSettingsModal] = useState(false);
	const [showCardTableModal, setShowCardTableModal] = useState(false);
	const [cardsOnTablePlayerId, setCardsOnTablePlayerId] = useState(-1);

	const [showDecisionModal, setShowDecisionModal] = useState(false);

	const [showACA, setShowACA] = useState(false); // ACA: active contracts and awards modal
	const [showCCA, setShowCCA] = useState(false); // CCA: completed contracts and awars modal
	const [showFC, setShowFC] = useState(false); // FC: failed contracts modal
	const [showEquipment, setShowEquipment] = useState(false); // show equipment modal

	const [showNewsCardsModal, setShowNewsCardsModal] = useState(false);

	const [showDiscardPileModal, setShowDiscardPileModal] = useState(false);

	const [recyclingCardId, setRecyclingCardId] = useState(-1);
	const [showTheFunny, setShowTheFunny] = useState(false);
	// const [isRecycling, setIsRecycling] = useState(false); // most likely unecessary

	const [pPE, setPPE] = useState(0); // purchase power energy
	const [pPC, setPPC] = useState(0); // purchase power carbon

	const [isDraggingEnergy, setIsDraggingEnergy] = useState(false);

	const [backgroundEffects, setBackgroundEffects] = useState(true);

	const [verboseUI, setVerboseUI] = useState(true);
	const [verboseAction, setVerboseAction] = useState(false);
	const [verboseSettings, setVerboseSettings] = useState(false);

	const audioRef = useRef(null);
	const [volume, setVolume] = useState(1);
	const [hasStarted, setHasStarted] = useState(false);
	const [isPlaying, setIsPlaying] = useState(false);

	/**
	 * UI functions
	 */

	function toggleMinimize() {
		logg('im minnin here');
		setMinimize((minimize) => !minimize);
	}

	// function viewCardTable() {
	// 	setCardsOnTablePlayerId(currPlayer.playerId);
	// 	setShowCardTableModal(!showCardTableModal);
	// }

	function viewNewsCards() {
		setShowNewsCardsModal(!showNewsCardsModal);
	}

	const closeCardTable = () => {
		setShowCardTableModal(false);
	};

	function toggleTicker() {
		setShowTicker((showTicker) => !showTicker);
	}

	function toggleVerboseUI() {
		setVerboseUI((verboseUI) => !verboseUI);
	}

	function toggleVerboseAction() {
		setVerboseAction((verboseAction) => !verboseAction);
	}

	function toggleVerboseSettings() {
		setVerboseSettings((verboseSettings) => !verboseSettings);
	}

	function equipmentAction(e, cardId) {
		e.preventDefault();
		const card = getCardMetadata(cardId);
		if (card.modifier === 'recyclingPlant') {
			closeCardTable();
			setRecyclingCardId(cardId);
			setShowDiscardCardFromHandModal(true);
		}
	}

	// function viewHand() {
	// 	logg('attempting to test hand');
	// 	if (myState.seasonalCards.length >= 0) {
	// 		logg('attempting to show hand');
	// 		let handBool = showHandModal;
	// 		// setSelectedAction("");
	// 		setShowHandModal(!handBool);
	// 	}
	// }

	function changeCamera() {
		let chanceOfFunny = 100;

		if (Math.floor(Math.random() * chanceOfFunny) + 1 === 1) {
			logg('Get RickRolled Kid');
			launchTheFunny();
		}

		// setPaymentMode((paymentMode) => !paymentMode);

		if (camState === 'player') {
			setCamState('payment');
		} else if (camState === 'payment') {
			setCamState('overhead');
			// } else if (camState === 'player') {
			// 	setCamState('close');
		} else {
			setCamState('player');
		}
	}

	function launchTheFunny() {
		setShowTheFunny(true);
		setTimeout(() => {
			// Kill Rick Roll after 1 minute
			setShowTheFunny(false);
		}, 62500);
	}

	function toggleTickerTimeout() {
		if (tickerTimeoutSeconds === 1) {
			setTickerTimeoutSeconds(3);
		} else if (tickerTimeoutSeconds === 3) {
			setTickerTimeoutSeconds(5);
		} else if (tickerTimeoutSeconds === 5) {
			setTickerTimeoutSeconds(10);
		} else if (tickerTimeoutSeconds === 10) {
			setTickerTimeoutSeconds(1);
		}
	}

	return {
		showHandModal,
		setShowHandModal,

		showDiscardCardFromHandModal,
		setShowDiscardCardFromHandModal,

		showPaymentModal,
		setShowPaymentModal,

		showCardTableModal,
		setShowCardTableModal,

		cardsOnTablePlayerId,
		setCardsOnTablePlayerId,

		showNewsCardsModal,
		setShowNewsCardsModal,

		showDecisionModal,
		setShowDecisionModal,

		minimize,
		setMinimize,

		playerMatPath,
		setPlayerMatPath,

		buyButtonTexturePath,
		setBuyButtonTexturePath,

		donateButtonTexturePath,
		setDonateButtonTexturePath,

		endTurnButtonTexturePath,
		setEndTurnButtonTexturePath,

		stealButtonTexturePath,
		setStealButtonTexturePath,

		storeButtonTexturePath,
		setStoreButtonTexturePath,

		payHereSignTexturePath,
		setPayHereSignTexturePath,

		showPlayermatModal,
		setShowPlayermatModal,

		showRulesmatModal,
		setShowRulesmatModal,

		showAdminStateModal,
		setShowAdminStateModal,

		showActionModal,
		setShowActionModal,

		showSettingsModal,
		setShowSettingsModal,

		showDiscardPileModal,
		setShowDiscardPileModal,

		recyclingCardId,
		setRecyclingCardId,

		showACA,
		setShowACA,
		showCCA,
		setShowCCA,
		showFC,
		setShowFC,
		showEquipment,
		setShowEquipment,

		setCamState,
		camState,
		changeCamera,

		showTicker,
		setShowTicker,

		backgroundEffects,
		setBackgroundEffects,

		setPPE,
		pPE,
		setPPC,
		pPC,

		isDraggingEnergy,
		setIsDraggingEnergy,

		verboseUI,
		verboseAction,
		verboseSettings,

		showTheFunny,
		setShowTheFunny,
		launchTheFunny,

		toggleMinimize,
		viewNewsCards,

		equipmentAction,
		closeCardTable,

		// viewCardTable,
		toggleTicker,

		toggleVerboseUI,
		toggleVerboseAction,
		toggleVerboseSettings,
		setVerboseSettings,

		// viewHand,

		audioRef,

		setVolume,
		volume,

		setHasStarted,
		hasStarted,

		setIsPlaying,
		isPlaying,

		paymentMode,
		setPaymentMode,

		currentTickerIndex,
		setCurrentTickerIndex,

		tickerActual,
		setTickerActual,

		currentTickerTimer,
		setCurrentTickerTimer,

		tickerTimeoutSeconds,
		setTickerTimeoutSeconds,
		toggleTickerTimeout,
	};
}
